<h2 mat-dialog-title>{{title}}</h2>
@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner>
      </mat-spinner>
    </div>
  </div>
}
<mat-dialog-content>
  @if (!resultReceived) {
    <div class="w-100 flex-col mt-3">
      <span>I want to represent a buyer for property:</span>
      <span class="uppercase mt-3"><b>{{property.header}}</b></span>
      <form [formGroup]="representForm" class="w-100 mt-5">
        <mat-form-field appearance="outline" class="w-100">
          <mat-icon matIconPrefix class="mr-1 text-muted">person</mat-icon>
          <mat-label>Buyers username</mat-label>
          <input matInput formControlName="username" required autocomplete="username">
          @if (representForm.controls.username.errors?.required) {
            <mat-error>Buyers username is required</mat-error>
          }
          @if (representForm.controls.username.hasError('minlength')) {
            <mat-error>Buyers username isn't long enough, minimum of 6 characters</mat-error>
          }
        </mat-form-field>
      </form>
    </div>
  }
  @if (resultReceived) {
    <div class="w-100 flex-col justify-center items-center mt-3">
      <span>{{resultText}}</span>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions >
  <div class="w-100 flex-row space-between items-center mt-3">
    @if (!resultReceived) {
      <button [disabled]="!canSubmit" class="w-40"  mat-flat-button color="primary" (click)="onConfirmClick()" tabindex="1" >{{confirmButtonText}}</button>
    }
    <button [disabled]="!canCancel" [ngClass]="resultReceived?'w-100':'w-40'" mat-flat-button color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
  </div>
</mat-dialog-actions>




